import classNames from "classnames";
import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section06Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const FeaturesSectionWithATitle = ({ job, page, section, ...props }: Section06Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Blocks && (
          <div className="flex flex-col gap-36">
            {section?.Blocks.map((block: any) => {
              return (
                <div
                  className={classNames("flex gap-8", {
                    "flex-row-reverse": block?.Orientation === "End",
                  })}
                  id={block?.HtmlId}
                  key={block?.id}
                >
                  <div
                    className={classNames("flex flex-1 items-center justify-center", {
                      "justify-end": block?.Orientation === "End",
                    })}
                  >
                    <div className="flex flex-col gap-10 lg:w-2/3">
                      {block?.Overline && <div className="font-bold uppercase text-blue-500">{block?.Overline}</div>}
                      {block?.Title && <div className="text-3xl font-bold">{block?.Title}</div>}
                      {block?.Body && <div className="text-vpGray-700">{block?.Body}</div>}
                      <div className="flex gap-4">
                        {block?.PrimaryButtonUrl && block?.PrimaryButtonValue && (
                          <Link href={block?.PrimaryButtonUrl ?? ""} variant="external">
                            <Button size="large">{block?.PrimaryButtonValue}</Button>
                          </Link>
                        )}
                        {block?.SecondaryButtonUrl && block?.SecondaryButtonValue && (
                          <Link href={block?.SecondaryButtonUrl ?? ""} variant="external">
                            <Button variant="text">{block?.SecondaryButtonValue}</Button>
                          </Link>
                        )}
                      </div>
                      {block?.Underline && <div className="text-vpBlue-500">{block?.Underline}</div>}
                    </div>
                  </div>
                  {block.Image?.data?.attributes && (
                    <div className="hidden lg:flex lg:flex-1 lg:justify-center">
                      <Image
                        alt={block?.Image?.data?.attributes?.alternativeText}
                        src={block?.Image?.data?.attributes?.url}
                        width={block?.Image?.data?.attributes?.width ?? "100"}
                        height={block?.Image?.data?.attributes?.height ?? "100"}
                        priority
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default FeaturesSectionWithATitle;
